import { apiErrorMessages } from '@/helpers/apiError';

import { apiClient } from './client';

export function getEasypostShipment (payload: { shipmentId: string; apiKey: string }) {
  return apiClient.post('/shipping/easypost/shipment', {
    shipment_id: payload.shipmentId,
    api_key: payload.apiKey,
  });
}

export function getEasypostCarriers (payload: { apiKey: string }) {
  return apiClient.post('/shipping/easypost/carriers', {
    api_key: payload.apiKey,
  });
}

/**
 * Queue label regeneration.
 *
 * `startDate` / `endDate` are optional and are forwarded verbatim. When present they
 * must be ISO-8601 instants in UTC with an explicit `Z`; `toUtcIsoString()` in
 * `UtcDateRangeSelect.vue` produces that form. When they are absent the request body is
 * byte-identical to the one this app sent before the date range existed, so whatever
 * window the API chose then it still chooses now. This repo cannot establish what that
 * window is, and callers must not claim it.
 */
export function retryLabels (payload: {
  shopId?: number | string;
  shippingIntegration?: string;
  startDate?: string;
  endDate?: string;
}) {
  return apiClient.post('/shipping/labels/generate', payload);
}

/**
 * Extract an operator-facing message from a failed `retryLabels()` call.
 *
 * Thin wrapper over the shared extractor: a Laravel 422 carries per-field messages under
 * `errors` and those win because they name the offending field, otherwise `message`,
 * otherwise the fallback below. Joined into one string because both callers render it
 * into a single `AlertBanner` description.
 */
export function retryLabelsErrorMessage (error: unknown): string {
  return apiErrorMessages(error, {
    fallback: 'Failed to queue label retry. Please try again.',
  }).join(' ');
}

export function getIntegrations (shopId: number | string) {
  return apiClient.get('/shipping/integrations', { params: { shop_id: shopId } });
}

export function getUpsByoaAccounts (shopId: number | string) {
  return apiClient.get('/shipping/ups-byoa-accounts', { params: { shop_id: shopId } });
}

export function updateAffiliatedMerchant (
  carrierShopId: number | string,
  affiliatedMerchant: string | null,
) {
  return apiClient.patch(`/shipping/carrier-shops/${carrierShopId}/affiliated-merchant`, {
    affiliated_merchant: affiliatedMerchant,
  });
}

export function uploadSendcloudInvoice (formData: FormData) {
  return apiClient.post('/shipping/sendcloud/invoice', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}
